import { createContext } from 'react';

import { Store, createStore } from '../../../core/store/store.js';
import { TreeMapState } from '../types/state.js';

export const initialTreeMapState: TreeMapState = {
  groupsSelected: [],
  highlightedItems: undefined,
  tooltip: {
    visible: true,
    pinned: false,
    content: undefined,
    position: undefined,
  },
  overlay: {
    mouseInBounds: false,
  },
  toolbar: {
    isHovered: false,
  },
  hierarchyLeafNodes: [],
  hierarchyClusterNodes: [],
  colorMap: new Map(),
};

export const TreeMapStateContext = createContext<Store<TreeMapState>>(
  createStore<TreeMapState>(initialTreeMapState),
);
